import React, { useEffect, useRef } from "react";
import ImgFebMidterm from "../assets/images/feb_midterm_design_1.png";
import Slide1 from "../assets/images/slide-1.png";
import Slide2 from "../assets/images/slide-2.png";
import Slide4 from "../assets/images/slide-4.png";
import ImgVolunteers from "../assets/images/volunteers.png";
import ImgHomeSchool from "../assets/images/home-school.png";
import SvgLocation from "../assets/svg/location.svg";
import EasterMakerImg from "../assets/images/easter_maker_camp_2026.png";
import SummerMakerClub2026 from "../assets/images/summer-maker-club-2026.jpg";
import VirtualSummerMakerClub2026 from "../assets/images/virtual-summer-maker-club-2026.jpg";
import { Link } from "react-router-dom";

const Hero: React.FC = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const initCarousel = () => {
      try {
        if (window.jQuery && carouselRef.current) {
          window.jQuery(carouselRef.current).carousel({
            interval: 5000,
            wrap: true,
            ride: "carousel",
          });
        }
      } catch (e) {
        console.error("Error with carousel:", e);
      }
    };
    initCarousel();
    const timer = setTimeout(initCarousel, 500);
    return () => clearTimeout(timer);
  });
  return (
    <div className="hero">
      <div className="container">
        <div className="hero-wrap">
          <div
            id="carouselExampleIndicators"
            className="carousel slide"
            data-ride="carousel"
            data-interval="5000"
            ref={carouselRef}
          >
            <ol className="carousel-indicators">
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="0"
                className="active"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="1"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="2"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="3"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="4"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="5"
              ></li>
            </ol>
            <div className="carousel-inner">
              {/*
                        <!-- <div class="carousel-item active">
                            <div class="image">
                                <img src="assets/img/Rwanda_Art_of_Engineering.jpg" alt="...">
                            </div>
                            <div class="carousel-caption d-none d-md-block">
                                <h5><img src="assets/svg/location.svg" alt="" srcset=""> Kigali</h5>
                                <p> The Art of Engineering</p>
                                <p class="extra">Join us in Kigali as we explore how the world of design meets engineering to create the gadgets and appliances you use every day!</p>
                                <a class="button-orange" href="https://bit.ly/decemberholiday24" target="_blank">sign up</a>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="image">
                                <img src="assets/img/Nigeria_Art_of_Engineeringjpg.jpg" alt="...">
                            </div>
                            <div class="carousel-caption d-none d-md-block">
                                <h5><img src="assets/svg/location.svg" alt="" srcset=""> Lagos and Port Harcourt</h5>
                                <p> The Art of Engineering</p>
                                <p class="extra">Join us in our Nigerian spaces as we explore how the world of design meets engineering to create the gadgets and appliances you use every day!</p>
                                <a class="button-orange" href="https://bit.ly/decemberholiday24" target="_blank">sign up</a>
                            </div>
                        </div>

                        <div class="carousel-item">
                            <div class="image">
                                <img src="assets/img/Kenya_Art_of_Engineering.jpg" alt="...">
                            </div>
                            <div class="carousel-caption d-none d-md-block">
                                <h5><img src="assets/svg/location.svg" alt="" srcset=""> Nairobi</h5>
                                <p> The Art of Engineering</p>
                                <p class="extra">Join us in Nairobi as we explore how the world of design meets engineering to create the gadgets and appliances you use every day!</p>
                                <a class="button-orange" href="https://bit.ly/decemberholiday24" target="_blank">sign up</a>
                            </div>
                        </div>

                        <div class="carousel-item">
                            <div class="image">
                                <img src="assets/img/open-day.png" alt="...">
                            </div>
                            <div class="carousel-caption d-none d-md-block">
                                <h5><img src="assets/svg/location.svg" alt="" srcset=""> Nigeria, Rwanda and Kenya</h5>
                                <p> Open Day</p>
                                <p class="extra">A FREE session for kids to explore the amazing world of STEM, learn through play, unlock creativity and innovate.  
                                    There will also be a 30-minutes session for parents and guardians to ask questions.
                                    </p>
                                <a class="button-orange" href="https://bit.ly/opendaydecember24" target="_blank">sign up</a>
                            </div>
                        </div> -->


                        <!-- <div class="carousel-item active">
                            <div class="image">
                                <img src="assets/img/stem_party.png" alt="...">
                            </div>
                            <div class="carousel-caption d-none d-md-block">
                                <h5><img src="assets/svg/location.svg" alt="" srcset=""> Lagos,  Port Harcourt</h5>
                                <p>Children’s Day Special</p>
                                <p class="extra">Join us for a day of STEM learning and fun!
                                </p>
                                <a class="button-orange" href="https://bit.ly/stemchildrenday25" target="_blank">sign up</a>
                            </div>
                        </div> -->
                          */}
              {/* <div className="carousel-item active"> */}
              {/*   <div className="image"> */}
              {/*     <img src={ImgBackInSession} alt="..." /> */}
              {/*   </div> */}
              {/*   <div className="carousel-caption d-none d-md-block"> */}
              {/*     <h5> */}
              {/*       <img src={SvgLocation} alt="" srcSet="" /> Nigeria, Rwanda */}
              {/*       and Kenya */}
              {/*     </h5> */}
              {/*     <p> School is back in session</p> */}
              {/*     <p className="extra"> */}
              {/*       It's a new class year. Don't leave the STEM fun out! */}
              {/*     </p> */}
              {/*     <Link */}
              {/*       className="button-orange" */}
              {/*       to="https://bit.ly/stemphysicalsessions25" */}
              {/*       target="_blank" */}
              {/*     > */}
              {/*       sign up */}
              {/*     </Link> */}
              {/*   </div> */}
              {/* </div> */}
              {/* <div className="carousel-item active"> */}
              {/*   <div className="image"> */}
              {/*     <img src={ImgFebMidterm} alt="Feb midterm banner" /> */}
              {/*   </div> */}
              {/*   <div className="carousel-caption d-none d-md-block"> */}
              {/*     <h5> */}
              {/*       <img src={SvgLocation} alt="" srcSet="" /> Yaba, Lagos */}
              {/*     </h5> */}
              {/*     <p>February Mid-term Programme is coming soon</p> */}
              {/*     <p className="extra"> */}
              {/*       Join us to explore the amazing world of aesthetics and */}
              {/*       functionality in Engineering this mid-term! */}
              {/*     </p> */}
              {/*     <Link */}
              {/*       className="button-orange" */}
              {/*       to="https://bit.ly/febmidterm2026" */}
              {/*       target="_blank" */}
              {/*     > */}
              {/*       Sign Up */}
              {/*     </Link> */}
              {/*   </div> */}
              {/* </div> */}
              <div className="carousel-item active">
                <div className="image">
                  <img
                    src={SummerMakerClub2026}
                    alt="Summer Maker Club Banner"
                  />
                </div>
                <div className="carousel-caption d-none d-md-block">
                  <h5>
                    <img src={SvgLocation} alt="" srcSet="" />
                    Lekki, Yaba, Port Harcourt
                  </h5>
                  <p>Summer Maker Club 2026</p>
                  <p className="extra">
                    Join us for a STEMtastic holiday adventure!
                  </p>
                  <Link
                    className="button-orange"
                    to="https://bit.ly/summermakerclub2026"
                    target="_blank"
                  >
                    Sign Up
                  </Link>
                </div>
              </div>
              <div className="carousel-item">
                <div className="image">
                  <img
                    src={VirtualSummerMakerClub2026}
                    alt="Virtual Summer Maker Club Banner"
                  />
                </div>
                <div className="carousel-caption d-none d-md-block">
                  <h5>Remote Learning</h5>
                  <p>Summer Maker Club 2026 Virtual</p>
                  <p className="extra">
                    Join us virtually for a STEMtastic holiday adventure!
                  </p>
                  <Link
                    className="button-orange"
                    to="https://bit.ly/summermakervirtual2026"
                    target="_blank"
                  >
                    Sign Up
                  </Link>
                </div>
              </div>
              <div className="carousel-item">
                <div className="image">
                  <img src={ImgVolunteers} alt="..." />
                </div>
                <div className="carousel-caption d-none d-md-block">
                  <h5>
                    <img src={SvgLocation} alt="" srcSet="" /> Nigeria, Rwanda
                    and Kenya
                  </h5>
                  <p>Volunteer with STEMCafe</p>
                  <p className="extra">
                    Join our team of educators across the globe as we take a
                    front seat in raising the next generation of innovators with
                    creative confidence.
                  </p>
                  <a
                    className="button-orange"
                    href="https://bit.ly/stemcafevolunteer"
                    target="_blank"
                  >
                    sign up
                  </a>
                </div>
              </div>
              <div className="carousel-item">
                <div className="image">
                  <img src={Slide1} alt="..." />
                </div>
                <div className="carousel-caption d-none d-md-block">
                  <h5>Designed for Kids</h5>
                  <p>Fun interactive science discovery through play.</p>
                  <a
                    className="button-orange"
                    href="https://stemcafe.typeform.com/to/Lacc0gDB"
                    target="_blank"
                  >
                    Book an activity
                  </a>
                </div>
              </div>
              <div className="carousel-item">
                <div className="image">
                  <img src={Slide2} alt="..." />
                </div>
                <div className="carousel-caption d-none d-md-block">
                  <h5>Virtual Session</h5>
                  <p>Discoveries are endless and fun. </p>
                  <a
                    className="button-orange"
                    href="https://bit.ly/stemvirtualsessions25"
                    target="_blank"
                  >
                    Book a Virtual session
                  </a>
                </div>
              </div>
              <div className="carousel-item">
                <div className="image">
                  <img src={ImgHomeSchool} alt="..." />
                </div>
                <div className="carousel-caption d-none d-md-block">
                  <h5>
                    <img src={SvgLocation} alt="" srcSet="" /> Nairobi, Kigali &
                    Lagos
                  </h5>
                  <p>Home Schoolers Maker Club.</p>
                  <p className="extra">
                    Join the Fun learning and explore the world of STEM
                    discoveries at our Markerspace
                  </p>
                  <a
                    className="button-orange"
                    href="http://forms.gle/vrGadEiMiKepWF5S6"
                    target="_blank"
                  >
                    sign up
                  </a>
                </div>
              </div>
              <div className="carousel-item">
                <div className="image">
                  <img src={Slide4} alt="..." />
                </div>
                <div className="carousel-caption d-none d-md-block">
                  <h5>Videos</h5>
                  <p>Subscribe to our YouTube channel </p>
                  <p className="extra">
                    <strong>
                      Get access to engaging fun activities to keep up the fun
                      Science discovery.{" "}
                    </strong>
                  </p>
                  <a
                    className="button-orange"
                    href="https://youtube.com/channel/UCCtRI-OFw-K3a7ydIdAvpCQ"
                    target="_blank"
                  >
                    subscribe
                  </a>
                </div>
              </div>
            </div>

            {/* Use regular anchor tags, not React Router Links */}
            <a
              className="carousel-control-prev"
              href="#carouselExampleIndicators"
              role="button"
              data-slide="prev"
              onClick={(e) => {
                e.preventDefault();
                // @ts-ignore - TypeScript doesn't know about carousel method
                window.jQuery("#carouselExampleIndicators").carousel("prev");
              }}
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#carouselExampleIndicators"
              role="button"
              data-slide="next"
              onClick={(e) => {
                e.preventDefault();
                // @ts-ignore - TypeScript doesn't know about carousel method
                window.jQuery("#carouselExampleIndicators").carousel("next");
              }}
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default Hero;
